import React from "react";

class DebugFilter extends React.Component {
  constructor(state, props) {
    super(state, props);
    this.state = { debug: "#neugier" };
  }

  onClickSearchFilter(name) {
    this.setState({
      debug: name
    });

    //pass the updated debug value back to parent (CheckRouteAndShowFilter)
    this.props.onChangeDebug(name);

    //jump to the selected anchor tag
    window.location.href = name;
  }

  componentDidMount() {
    //current filter value
    this.setState({
      debug: this.props.debug
    });
  }

  render() {
    return (
      <div className="row text-center centre-row-margin">
        <div className="filterOutline">
          <span className="text-muted filterText">
            <b>Debug Modes </b>&nbsp;
          </span>
          <select
            className="select-styling"
            onChange={evt => this.onClickSearchFilter(evt.target.value)}
            value={this.state.debug}
          >
            <option value="#neugier">Neugier</option>
            <option value="#illusion">Illusion of Gaia</option>
            <option value="#ace">Aim for the Ace!</option>
            <option value="#wozz">Wozz</option>
            <option value="#mickey3">Magical Quest 3</option>
            <option value="#doremi">DoReMi Fantasy</option>
          </select>
        </div>
      </div>
    );
  }
}

export default DebugFilter;



// WEBPACK FOOTER //
// ./src/lib/DebugFilter.js